import { Component, EventEmitter, Input, Output, NgModule, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

import { CheckboxRoutingModule } from './checkbox.routing.module';

@Component({
  selector: 'checkbox',
  template: `
  <div class="md-form" *ngIf="visible" [ngClass]="{'has-error':error}" [formGroup]="form">
    <fieldset class="form-group">
      <input type="checkbox" id="{{name}}" class="form-control {{className}}" [formControl]="control" [ngClass]="{'invalid':error}">
      <label for="{{name}}">
        <em *ngIf="readonly">{{caption}}</em>
        <b *ngIf="!readonly">{{caption}}</b>
        <span *ngIf="required" style="color: red;">
          <b>*</b>
        </span>
      </label>
      <span *ngIf="error" class="help-block text-danger" style="font-size: 15px">
        <b>{{ error }}</b>
      </span>
    </fieldset>
  </div>`,
  styles: [`
  [type="checkbox"] + label {
    padding-left: 30px;
    margin-bottom: 20px;
  }`],
  encapsulation: ViewEncapsulation.None
})

export class CheckboxComponent {
  @Input() public name: string = '';
  @Input() public caption: string = '';
  @Input() public enabled: Boolean = false;
  @Input() public value: Boolean = false;
  @Input() public form: FormGroup;
  @Input() public error: any;
  @Input() public glyph: any;
  @Input() public className: String;
  @Output() public updated = new EventEmitter<Boolean>();
  @Input() public visible: boolean = true;
  @Input() public control: AbstractControl;
  @Input() public required: boolean = false;
  @Input() public readonly: boolean = false;

  ngOnInit() {
    if (!this.control) {
      if (this.form.controls[this.name] == null) {
        this.control = new FormControl();
        this.form.addControl(this.name, this.control);
      }
      this.control = this.form.controls[this.name];
    }
    this.control.valueChanges.subscribe((value) => {
      this.updated.emit(value);
    });
  }
}
